export default {
  black: "#151515",
  mainColor: "#00B7EF",
  button: "#FBAA5C",
  bgBlackColor: "#1a1a1a",
  bgColor: "#f6f6f6",
  darkGrey: "#999",
  lightGrey: "#e6e6e6",
  navy: "#1D3548",
  navyDarkGrey: "#2A394B",
  navbar: "#c0392b",
  iconColor: "#3F0000",
};
